// extracted by mini-css-extract-plugin
export default {"descriptionCard":"ProjectDescription_descriptionCard__OQkf1"};